module.exports = __webpack_public_path__ + "assets/media/zoom-icon.cbcb5c90.svg";